module.exports = __webpack_public_path__ + "static/media/label_important.fdee27d7.svg";